import { createContext, useSyncExternalStore } from "react";

export interface HeaderSlots { title: HTMLElement | null; actions: HTMLElement | null; mobileActions: HTMLElement | null }
export const HeaderSlotContext = createContext<HeaderSlots | null>(null);

const MQ = "(min-width: 1024px)";
const subscribe = (cb: () => void) => {
  const m = window.matchMedia(MQ);
  m.addEventListener("change", cb);
  return () => m.removeEventListener("change", cb);
};
export const useIsDesktop = () => useSyncExternalStore(subscribe, () => window.matchMedia(MQ).matches, () => true);
